import { atom } from "jotai";

/**
 * Tour intro step state - stores the intro step information when a tour is starting
 */
export const tourIntroStepAtom = atom<{
  header: string;
  description: string;
  totalSteps: number;
} | null>(null);
tourIntroStepAtom.debugLabel = "tourIntroStepAtom";

/**
 * Node explanation state - tracks which node is currently being explained
 * Set to nodeId when starting explanation, null when done
 */
export const nodeIdToExplainAtom = atom<string | null>(null);
nodeIdToExplainAtom.debugLabel = "nodeIdToExplainAtom";

/**
 * Tour alert visibility state - controls whether the tour completion alert is shown
 */
export const isTourAlertVisibleAtom = atom<boolean>(false);
isTourAlertVisibleAtom.debugLabel = "isTourAlertVisibleAtom";

/**
 * Tour generation state - tracks whether a tour is currently being generated
 */
export const isGeneratingTourAtom = atom<boolean>(false);
isGeneratingTourAtom.debugLabel = "isGeneratingTourAtom";

/**
 * Explanation generation state - tracks whether an explanation is currently being generated
 */
export const isGeneratingExplanationAtom = atom<boolean>(false);
isGeneratingExplanationAtom.debugLabel = "isGeneratingExplanationAtom";

/**
 * Combined state atom that tracks if any tour or explanation operation is running.
 * NOTE: Don't accidentally add isGeneratingTourAtom or isGeneratingExplanationAtom
 * to other combined atoms - they should only be used here for this specific check.
 */
export const isTourOrExplanationRunningAtom = atom(
  (get) => get(isGeneratingTourAtom) || get(isGeneratingExplanationAtom),
);
isTourOrExplanationRunningAtom.debugLabel = "isTourOrExplanationRunningAtom";

/**
 * Loading indicator message atom - determines the appropriate loading message
 * based on the current operation type (tour vs explanation)
 */
export const tourLoadingIndicatorMessageAtom = atom((get) => {
  const isGeneratingTour = get(isGeneratingTourAtom);

  return isGeneratingTour ? "Loading tour..." : "Loading explanation...";
});
tourLoadingIndicatorMessageAtom.debugLabel = "tourLoadingIndicatorMessageAtom";
